function daysHoursMins(days, that) {
  if (Math.abs(days) < 1) {
    return (
      Math.round(parseInt(days * 24)) +
      that.$i18n_t('IS.FM.AccessMgmt.hoursAnd') +
      Math.round(((days * 24) % 1) * 60) +
      that.$i18n_t('IS.FM.AccessMgmt.mins')
    );
  } else {
    return Math.round(days) + that.$i18n_t('IS.FM.AccessMgmt.days');
  }
}

function userAccessRightHandling(responseError, that) {
  let errorMessage = '';
  // Level 1
  if (responseError && responseError.hours) {
    let hoursDifference = Math.abs(responseError.hours.hoursLeft);
    let minsDifference = Math.abs(responseError.hours.minsLeft);
    errorMessage =
      that.$i18n_t('IS.FM.AccessMgmt.accIn') +
      Math.round(hoursDifference) +
      that.$i18n_t('IS.FM.AccessMgmt.hoursAnd') +
      minsDifference +
      that.$i18n_t('IS.FM.AccessMgmt.mins');
  }
  // Level 2
  if (responseError && responseError.daysAllowed) {
    const daysList = [
      {
        dayId: 1,
        dayText: that.$i18n_t('Common.Monday'),
      },
      {
        dayId: 2,
        dayText: that.$i18n_t('Common.Tuesday'),
      },
      {
        dayId: 3,
        dayText: that.$i18n_t('Common.Wednesday'),
      },
      {
        dayId: 4,
        dayText: that.$i18n_t('Common.Thursday'),
      },
      {
        dayId: 5,
        dayText: that.$i18n_t('Common.Friday'),
      },
      {
        dayId: 6,
        dayText: that.$i18n_t('Common.Saturday'),
      },
      {
        dayId: 0,
        dayText: that.$i18n_t('Common.Sunday'),
      },
    ];

    responseError.daysAllowed.sort();
    const forbiddenDays = responseError.daysAllowed.map((day) => {
      return daysList.find((dayObj) => dayObj.dayId === day).dayText;
    });
    errorMessage = that.$i18n_t('IS.FM.AccessMgmt.onlyAllOn') + forbiddenDays.join(', ');
  }
  // Level 3
  if (responseError && responseError.days) {
    let daysDifference = responseError.days.daysDifferenceFrom;
    let daysDifferenceTo = responseError.days.daysDifferenceTo;
    if (daysDifference < 0 && daysDifferenceTo < 0) {
      errorMessage = that.$i18n_t('IS.FM.AccessMgmt.accIn') + this.daysHoursMins(-daysDifference, that);
    }
    if (daysDifferenceTo > 0) {
      errorMessage = that.$i18n_t('IS.FM.AccessMgmt.expSnc') + this.daysHoursMins(-daysDifferenceTo, that);
    }
  }
  return errorMessage;
}

export default {
  daysHoursMins,
  userAccessRightHandling,
};
